"use client";

import Logo from "@/components/Logo";
import Menu from "@/components/Menu";
import Social from "@/components/Social";
import { useState, useEffect } from "react";

function checkIsMobile() {
  if (typeof window !== 'undefined') {
    return window.innerWidth < 768;
  }
  return false;
}

function Footer() {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    setIsMobile(checkIsMobile());
    const handleResize = () => setIsMobile(checkIsMobile());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <footer>
      <div className="container py-4 border-side-default">
        <div className="block md:flex justify-between">
          <div className="flex-1">
            {!isMobile ? (
              <div className="flex items-center">
                <div className="mt-0 md:mt-[-3px]">
                  <Logo />
                </div>
                <div className="ml-5">
                  <Menu />
                </div>
              </div>
            ) : (
              <>
                <div className="flex justify-between items-start">
                  <Logo className="mt-[-5px]" />
                  <Social />
                </div>
                <Menu orientation="vertical" align="left" className="mt-4" />
              </>
            )}
          </div>
          {!isMobile && (
            <div className="flex-1 flex items-start justify-end">
              <Social />
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}

export default Footer;